import React from "react";

import { useState, useContext } from "react";

// @mui material components
import Api from "../../Classes/API/UsersApi";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import TextField from "@mui/material/TextField";

import MDTypography from "components/MDTypography";

import { LanguageContext } from "App";
import Button from "@mui/material/Button";

import MDInput from "components/MDInput";

import CardHeader from "@mui/material/CardHeader";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CreateTherapistEmployeeTypeReq from "Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq";

const CreateEmployeeType = () => {
  const [EmployeeTypeName, SetEmployeeTypeName] = useState("");
  const [EmployeeTypeHourlyRate, SetEmployeeTypeHourlyRate] = useState("");
  const [ErrorText, SetErrorText] = useState(false);
  const [Req, SetReq] = useState({});
  const { translations } = useContext(LanguageContext);
  const submitForm = async () => {
    if (!EmployeeTypeName || !EmployeeTypeHourlyRate) {
      if (!EmployeeTypeName) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterEmployeeTypeName,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      if (!EmployeeTypeHourlyRate) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterEmployeeTypeHourlyRate,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      SetErrorText(true);
      return;
    }
    let req = new CreateTherapistEmployeeTypeReq();
    req.TypeName = EmployeeTypeName;
    req.StandardHourlyRate = EmployeeTypeHourlyRate;

    await Api.CreateNewEmployeeType(req).then((result) => {
      if (result.status == "Success") {
        Swal.fire("Success", "EmployeeType created successfully", "success");
      } else {
        Swal.fire("Failed", "EmployeeType creation failed", "error");
      }
    });
  };

  return (
    <div>
      <DashboardLayout>
        {/* Page Title */}
        <DashboardNavbar />

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader
              className="mb-2"
              title={translations.EmployeeTypetableCreateEmployeeType}
            ></CardHeader>
            <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
              <div className="container-fluid">
                <div className="row">
                  {/* Employee type name */}
                  <div className="col-md-4">
                    <MDInput
                      label={translations.EmployeeTypetableEmployeetypename}
                      onChange={(e) => SetEmployeeTypeName(e.target.value)}
                      fullWidth
                    />
                  </div>

                  {/* standard Hourly Rate */}
                  <div className="col-md-4">
                    <TextField
                      label={translations.EmployeeTypeEmployeeTypeHourlyRate}
                      type="number"
                      onChange={(e) => SetEmployeeTypeHourlyRate(e.target.value)}
                      fullWidth
                    />
                  </div>
                </div>
              </div>

              <div className="text-right mt-3 ">
                <Button
                  className="white"
                  sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                  size="medium"
                  onClick={submitForm}
                >
                  {translations.EmployeeTypetableSave}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </div>
  );
};

export default CreateEmployeeType;
